import __ from "src/utils/Translations";
import { HistoryAction } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";

export default (action: HistoryAction) => {
  if (action === HistoryAction.CREATION) {
    return __("Utworzenie wniosku");
  }

  if (action === HistoryAction.EDITION) {
    return __("Edycja");
  }

  return __("Zmiana statusu");
};
